import { inject, injectable } from "inversify";
import { ICPLFundSchedulesClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IFundSchedulesService {
  getSelectModels(isServiceChargeOnly?: boolean, developmentIDs?: string[]): Promise<IntSelectModel[]>;
  getFundScheduleChargeTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class FundSchedulesService implements IFundSchedulesService {
  @inject(SERVICE_TYPES.CPLFundSchedulesClient) cplFundSchedulesClient!: ICPLFundSchedulesClient;

  async getSelectModels(isServiceChargeOnly?: boolean, developmentIDs?: string[]): Promise<IntSelectModel[]> {
    return this.cplFundSchedulesClient.getSelectModels(isServiceChargeOnly, developmentIDs);
  }

  async getFundScheduleChargeTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplFundSchedulesClient.getFundScheduleChargeTypesSelectModels();
  }
}
